import React from "react";

// F54: one broken widget shows a small notice instead of blanking the whole case page.
export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error) { console.error(`[${this.props.name || "section"}]`, error); }
  componentDidUpdate(prev) { if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null }); }
  render() {
    if (this.state.error) {
      return (
        <div className="rounded-2xl border border-[#CA1212]/30 bg-[#CA1212]/5 p-4 text-xs text-[#CA1212]" data-testid={`section-error-${(this.props.name || "section").toLowerCase().replace(/\s+/g, "-")}`}>
          Couldn't load this section{this.props.name ? ` (${this.props.name})` : ""}. <button onClick={() => this.setState({ error: null })} className="underline">Retry</button>
        </div>
      );
    }
    return this.props.children;
  }
}
